module.exports = __webpack_public_path__ + "static/media/03.267c8cc9.webp";